// extracted by mini-css-extract-plugin
export default {"productContainer":"Products_productContainer__S7NDn","description":"Products_description__9Stjd"};